import * as Sentry from '@sentry/browser';
import { useAuthState } from './auth';

export const RegisterSentryUser = () => {
  const { user } = useAuthState();
  if (user) {
    Sentry.getCurrentScope().setUser({
      email: user.email,
      id: String(user.id),
    });
  }
  return null;
};
